import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { db } from '../../../../firebase';
import { collection, onSnapshot } from 'firebase/firestore';
import { userStatsLoadedAction } from '../../../actions/user';
import { dataCompletedAction } from '../../../actions/store';

const useUserStatsLoader = () => {
  const [options, setOptions] = useState({ execute: false });

  const user = useSelector(state => state.user);
  const dispatch = useDispatch();

  const load = () => {
    dispatch(dataCompletedAction({ slice: 'User', path: 'stats' }));
    return onSnapshot(
      collection(db, `users/${user.userID}/stats`),
      querySnapshot => {
        const items = [];

        querySnapshot.forEach(doc => {
          const dataItem = doc.data();
          dataItem.id = doc.id;
          items.push(dataItem);
        });

        dispatch(userStatsLoadedAction(items));
      },
      error => {
        console.error('useUserStatsLoader.onSnapshot', error);
      }
    );
  };

  useEffect(() => {
    let unSub = () => {};
    if (options.execute) {
      unSub = load();
    }
    return () => {
      unSub();
    };
  }, [options]);

  return {
    loadUserStats: (options = {}) => {
      setOptions({ ...options, execute: true });
    }
  };
};

export default useUserStatsLoader;
